module.exports = __webpack_public_path__ + "img/storage.3f2740f9.svg";